'use client';

import Image from "next/image";
import { useMemo, useState } from "react";
import { LANGUAGE_ICON_MAP } from "@/features/user-center/constants";
import useSwitchLanguage from "@/features/user-center/hooks/useSwitchLanguage";
import IconFont from '@/components/ui/iconFont';
import clsx from "clsx";

export default function SelectLang() {
  const [isOpen, setIsOpen] = useState(false);
  const { language, showLanguageSelect } = useSwitchLanguage({ needSync: false });
  const langImg = useMemo(() => LANGUAGE_ICON_MAP[language || 'en-US'], [language]);

  const handleShowLanguageSelect = async () => {
    setIsOpen(true);
    await showLanguageSelect(false);
    setIsOpen(false);
  };

  return (
    <div className="flex items-center justify-between ml-4 px-[10px] rounded-[8px] w-[67px] h-[30px] bg-black/30 mt-[4px]" onClick={handleShowLanguageSelect}>
      <Image src={langImg} alt="lang" width={16} height={16} />
      <div className="h-[16px] w-[1px] bg-[rgba(214,234,255,0.1)]"></div>
      <IconFont
        name="arrow-down"
        size={7}
        color="#a9b5cb"
        className={clsx("transition-transform", isOpen ? 'rotate-180' : 'rotate-0')}
      />
    </div>
  );
}